import { studies } from '@ohif/core';

export const SearchByAccessionNumber = async ({ AccessionNumber, server }) => {
  let StudyInstanceUID;

  const studyMetadata = await studies.searchStudies(server, { AccessionNumber });
  if (studyMetadata) {
    StudyInstanceUID = studyMetadata[0].StudyInstanceUID;
  }

  return StudyInstanceUID;
};
